import { Expose } from 'class-transformer';

export class ReferralTypeDto {
  @Expose()
  uuid: string;

  @Expose()
  title: string;
}
